<template>
  <b-notification :has-icon="true" :icon="'unlink'" :closable="false">
    <strong>
      {{ $t('compCarbonFormsSurveyObsoleteLink.obsolete-title') }}
    </strong>
    <br />
    {{ $t('compCarbonFormsSurveyObsoleteLink.obsolete-1') }}
    <strong>{{ entityName }}</strong>
    {{ $t('compCarbonFormsSurveyObsoleteLink.obsolete-2') }}.
    <br />
    {{ $t('compCarbonFormsSurveyObsoleteLink.obsolete-3') }}
    <a class="link" :href="'mailto:' + contactEmail">
      {{ contactEmail }}
    </a>
  </b-notification>
</template>

<script>
export default {
  name: 'ObsoleteLink',
  props: {
    entityName: {
      type: String,
      required: true
    },
    contactEmail: {
      type: String,
      required: true
    }
  }
}
</script>
